import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=72d1ac7a&scoped=true"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
import style0 from "./UnsavedChangesModal.vue?vue&type=style&index=0&id=72d1ac7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1ac7a",
  null
  
)

export default component.exports